import { StyleTypesApiEnum } from '../../../api/styles/enum/style-types-api.enum';

export enum WireBlockTypeEnum {
    text = 'TEXT',
    image = 'IMAGE',
    video = 'VIDEO',
    links = 'SOCIAL_LINKS',
    contact = 'CONTACT',
    companyLogo = 'COMPANY_LOGO',

    // F.E fake block types
    companyBio = 'COMPANY_BIO',
    companyAddress = 'COMPANY_ADDRESS'
}

export enum WireBlockTypeApiEnum {
    text = 'TEXT',
    image = 'IMAGE',
    video = 'VIDEO',
    links = 'SOCIAL_LINKS',
    contact = 'CONTACT',
    companyBio = 'COMPANY_BIO',
}


export const wireBlockTypeEnumToWireBlockTypeApiEnum: Map<WireBlockTypeEnum, WireBlockTypeApiEnum> = new Map([
    [WireBlockTypeEnum.text, WireBlockTypeApiEnum.text],
    [WireBlockTypeEnum.image, WireBlockTypeApiEnum.image],
    [WireBlockTypeEnum.video, WireBlockTypeApiEnum.video],
    [WireBlockTypeEnum.links, WireBlockTypeApiEnum.links],
    [WireBlockTypeEnum.contact, WireBlockTypeApiEnum.contact],
    [WireBlockTypeEnum.companyBio, WireBlockTypeApiEnum.companyBio],
]);

export const wireBlockTypeApiEnumToWireBlockTypeEnum: Map<WireBlockTypeApiEnum, WireBlockTypeEnum> = new Map([
    [WireBlockTypeApiEnum.text, WireBlockTypeEnum.text],
    [WireBlockTypeApiEnum.image, WireBlockTypeEnum.image],
    [WireBlockTypeApiEnum.video, WireBlockTypeEnum.video],
    [WireBlockTypeApiEnum.links, WireBlockTypeEnum.links],
    [WireBlockTypeApiEnum.contact, WireBlockTypeEnum.contact],
    [WireBlockTypeApiEnum.companyBio, WireBlockTypeEnum.companyBio],
]);

export const styleTypeApiEnumToWireBlockTypeEnum = new Map<StyleTypesApiEnum, WireBlockTypeEnum>([
    [StyleTypesApiEnum.TEXT, WireBlockTypeEnum.text],
    [StyleTypesApiEnum.IMAGE, WireBlockTypeEnum.image],
    [StyleTypesApiEnum.VIDEO, WireBlockTypeEnum.video],
    [StyleTypesApiEnum.LINKS, WireBlockTypeEnum.links],
    [StyleTypesApiEnum.CONTACT, WireBlockTypeEnum.contact],
]);
